export const BUILD_VERSION = '1793777330';
